import { render, staticRenderFns } from "./initiatingShare.vue?vue&type=template&id=4834793a&scoped=true&"
import script from "./initiatingShare.vue?vue&type=script&lang=js&"
export * from "./initiatingShare.vue?vue&type=script&lang=js&"
import style0 from "./initiatingShare.vue?vue&type=style&index=0&id=4834793a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4834793a",
  null
  
)

export default component.exports